<template>
	<div
		:id="`fact-box-${_uid}`"
		:class="[
			'c-block-list-fact-box-custom',
			'w-5col >=768:w-8col max-w-full mx-auto',
		]"
	>
		<LongReadTarget
			v-if="title"
			:container-id="`fact-box-${_uid}`"
			:title="title"
		>
			<BaseH2 class="text-primary-button mb-sm" v-text="title" />
		</LongReadTarget>

		<div
			:class="[
				'flex flex-col >=768:flex-row gap-x-layout-gutter gap-y-md',
				'bg-primary-light rounded-lg w-full p-md',
			]"
		>
			<UmbracoImageExt
				v-if="image && image.localCrops"
				:widths="[320, 410, 480, 320 * 2, 410 * 2, 480 * 2]"
				:alt="image.content.altText"
				:source-url="image.localCrops"
				:source-width="image.content.umbracoWidth"
				:source-height="image.content.umbracoHeight"
				:aspect-ratio="4 / 3"
				class="
					w-full
					h-fit
					>=768:w-3col
					flex-shrink-0
					rounded-sm
					overflow-hidden
				"
			></UmbracoImageExt>

			<div
				v-if="text && text.length"
				class="s-rich-text w-full px-4 >=768:py-4 >=768:px-0"
				v-html="text"
			></div>
		</div>
	</div>
</template>

<script>
import LongReadTarget from '~/citi-baseline/components/LongReadTarget';
import UmbracoImageExt from '~/components/shared/UmbracoImageExt';

export default {
	name: 'BlockListFactBoxCustom',
	components: { LongReadTarget, UmbracoImageExt },
	inheritAttrs: false,

	props: {
		text: String,
		title: String,

		image: {
			type: Object,
			required: false,
		},
	},
};
</script>
